import { Injectable } from '@angular/core';
import {
  type OrderHistoryFilter,
  type OrderHistoryFilterSortPageModel,
  OrderHistorySortByOptions,
  type OrderHistorySortByValueType,
  ServicePaginationConfigDefaultLimit,
  ServicePaginationConfigDefaultPage,
} from '@libs/services/models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderHistoryStateService {
  public page$: BehaviorSubject<number> = new BehaviorSubject<number>(ServicePaginationConfigDefaultPage);
  public limit$: BehaviorSubject<number> = new BehaviorSubject<number>(ServicePaginationConfigDefaultLimit);
  public sort$: BehaviorSubject<OrderHistorySortByValueType> = new BehaviorSubject<OrderHistorySortByValueType>(OrderHistorySortByOptions[0].value);
  public filter$: BehaviorSubject<OrderHistoryFilter | null> = new BehaviorSubject<OrderHistoryFilter | null>(null);

  public getParams(): OrderHistoryFilterSortPageModel {
    return {
      page: this.page$.getValue(),
      limit: this.limit$.getValue(),
      sort: this.sort$.getValue(),
      filter: this.filter$.getValue() ?? {},
    };
  }

  public setParams(params: OrderHistoryFilterSortPageModel): void {
    this.page$.next(params.page);
    this.limit$.next(params.limit);
    this.sort$.next(params.sort);
    this.filter$.next(params.filter);
  }
}
